(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/subscription/subscription.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/subscription/subscription.js');

'use strict';

function parseSubscription() {
  let {
    subscription,
    customer
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!subscription) {
    return;
  }
  let multipleDaysDetails = {};
  const {
    wager,
    jokerWager
  } = getSubwagers(subscription.subwagers);
  const descriptions = getDescriptions(wager);
  const wagerType = getWagerType(subscription, descriptions.drawsPerWeek);
  const betAmounts = getBetAmounts(subscription, descriptions.drawsPerWeek);
  const bet = getBet(wager);
  const jokerBet = getJokerBet(jokerWager);
  if (svs.numbergames.productMapping.isProductFamily(bet.productId)) {
    multipleDaysDetails = getMultipleDaysDetails(bet.productId, subscription);
  }
  bet.drawBetAmount = betAmounts.drawBetAmount;
  if (jokerBet) {
    jokerBet.drawBetAmount = betAmounts.addonAmount;
  }
  return {
    channel: 'Prenumeration',
    isSubscription: true,
    productId: bet.productId,
    paymentType: customer && customer.paymentType,
    subscriptionId: subscription.subscrId,
    hasJoker: subscription.hasJoker,
    isEditableSubscription: subscription.status === 2 && subscription.currIntervalPaystate !== 3,
    nextDraw: subscription.nextDraw,
    createdDate: subscription.createdDate,
    currIntvFrom: subscription.currIntvFrom,
    currIntvTo: subscription.currIntvTo,
    prevPayDate: subscription.prevPayDate && subscription.prevPayDate.split('T')[0],
    prevPayAmount: subscription.prevPayAmount,
    productName: descriptions.productName,
    description: descriptions.description,
    extraDescription: descriptions.extraDescription,
    rowCount: descriptions.rowCount,
    drawsPerWeek: descriptions.drawsPerWeek,
    isSingleWager: wagerType.isSingleWager,
    isSystemWager: wagerType.isSystemWager,
    isPackageWager: wagerType.isPackageWager,
    weeklyAmount: betAmounts.weeklyAmount,
    addonAmount: betAmounts.addonAmount,
    hasLotto2: svs.numbergames.productMapping.isLotto(bet.productId) && wager.numDraws === 2,
    weekDays: multipleDaysDetails.weekDays,
    gameDays: multipleDaysDetails.gameDays,
    bet,
    jokerBet
  };
}

function getDescriptions() {
  let bet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    productName: bet.productName,
    description: bet.description,
    extraDescription: bet.extraDescription,
    rowCount: bet.numRows,
    drawsPerWeek: bet.productIds && bet.productIds.length
  };
}

function getWagerType(subscription, drawsPerWeek) {
  const {
    isPackage,
    packageId1,
    packageId2
  } = subscription;
  const isSystemWager = subscription.isSystem;
  const isPackageWager = !isSystemWager && checkIfPackageWager(isPackage, packageId1, packageId2, drawsPerWeek);
  const isSingleWager = !isPackageWager && !isSystemWager;
  return {
    isSingleWager,
    isSystemWager,
    isPackageWager
  };
}

function checkIfPackageWager(isPackage, packageId1, packageId2, drawsPerWeek) {
  if (isPackage) {
    packageId1 = parseInt(packageId1, 10);
    packageId2 = parseInt(packageId2, 10);
    const hasPackageId1 = Boolean(packageId1);
    const hasPackageId2 = Boolean(packageId2);

    let isOldStylePackageIds = false;


    if (hasPackageId1 && hasPackageId2) {
      isOldStylePackageIds = packageId1 === packageId2;
    }

    if (hasPackageId1 !== hasPackageId2) {
      isOldStylePackageIds = drawsPerWeek === 2;
    }
    if (isOldStylePackageIds) {
      isPackage = false;
    }
  }
  return isPackage;
}

function getBetAmounts(subscription, drawsPerWeek) {
  const weeklyAmount = parseInt(subscription.weeklyAmount, 10) || 0;
  const addonAmount = parseInt(subscription.addonAmount, 10) || 0;
  const drawBetAmount = (weeklyAmount - addonAmount * drawsPerWeek) / drawsPerWeek;
  return {
    weeklyAmount,
    addonAmount,
    drawBetAmount
  };
}

function getSubwagers(subwagers) {
  if (Array.isArray(subwagers)) {
    let wager;
    let jokerWager;
    subwagers.forEach(subwager => {
      if (svs.numbergames.productMapping.isJoker(subwager.productName)) {
        jokerWager = subwager;
      } else {
        wager = subwager;
      }
    });
    return {
      wager,
      jokerWager
    };
  }
}

function getBet(wager) {
  if (wager && Array.isArray(wager.productIds)) {
    const [productId1] = wager.productIds;
    return {
      boards: wager.boards,
      productId: svs.numbergames.productMapping.getProductId(productId1)
    };
  }
}

function getJokerBet(wager) {
  if (wager && Array.isArray(wager.boards)) {
    let boards;
    let board;
    if (Array.isArray(wager.boards[0])) {
      board = wager.boards[0];
    } else if (Array.isArray(wager.boards[0].boardValues)) {
      board = wager.boards[0].boardValues;
    }

    const numbers = board[0];
    if (board) {
      boards = [{
        numbers: Array.prototype.slice.call(numbers)
      }];
    }
    return {
      productId: 'JOKER',
      boards
    };
  }
}


function getMultipleDaysDetails(productId, subscription) {
  const [bet] = subscription.subwagers;
  let weekDays;
  if (bet.productIds.length > 1) {
    switch (productId) {
      case svs.numbergames.productMapping.CONSTANTS.LOTTO:
        weekDays = 'Onsdag & Lördag';
        break;
      case svs.numbergames.productMapping.CONSTANTS.EUROJACKPOT:
        weekDays = 'Tisdag & Fredag';
        break;
      default:
    }
  } else {
    weekDays = svs.numbergames.productMapping.getDay(bet.productIds[0]);
  }
  const gameDays = bet.productIds.map(id => svs.numbergames.productMapping.getProductItsId(id));
  return {
    weekDays,
    gameDays
  };
}
svs.numbergames.mybets_core_wager.parsers.subscription = {
  parseSubscription,
  getDescriptions,
  getWagerType,
  checkIfPackageWager,
  getBetAmounts,
  getSubwagers,
  getBet,
  getJokerBet,
  getMultipleDaysDetails
};

 })(window);